import './App.css';

function App() {
  return (
    <div className="App">
      <div className="logo-header-content">
        <h1 className="logo-header-first text-9xl font-extrabold">KLEINCOMPUTER</h1>
        <h1 className="logo-header-second text-9xl font-extrabold text-red-300">KLEINCOMPUTER</h1>
        <h1 className="logo-header-third text-9xl font-extrabold text-blue-300">KLEINCOMPUTER</h1>
      </div>
    </div>
  );
}

export default App;
